var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95974 33.6093H3.57649C2.15942 33.6093 1 32.4423 1 31.016V9.81637C1 8.3901 2.15942 7.22314 3.57649 7.22314H38.4235C39.8406 7.22314 41 8.3901 41 9.81637V31.016C41 32.4423 39.8406 33.6093 38.4235 33.6093H11.1127",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4282 28.7471H40.9999",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06421 28.7471H10.9193",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5171 31.2104H21.5477",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6055 38.0832H16.459L17.6828 33.6099H24.3817L25.6055 38.0832Z",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2156 41H14.8485C14.0755 41 13.4314 40.3517 13.4314 39.5737C13.4314 38.7958 14.0755 38.1475 14.8485 38.1475H27.2156C27.9886 38.1475 28.6327 38.7958 28.6327 39.5737C28.6327 40.3517 27.9886 41 27.2156 41Z",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0807 7.80713V11.1783",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54291 28.7475V7.80713",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0807 25.1167V28.7472",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0807 7.80723V7.54791C31.0807 5.79748 29.6637 4.3712 27.9246 4.3712H17.1677L15.2353 1H7.69911C5.95998 1 4.54291 2.42628 4.54291 4.17671V7.80723",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50237 4.436C9.50237 5.0843 8.98708 5.60295 8.34295 5.60295C7.69883 5.60295 7.18353 5.0843 7.18353 4.436C7.18353 3.78769 7.69883 3.26904 8.34295 3.26904C8.98708 3.33387 9.50237 3.85252 9.50237 4.436Z",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3366 5.60295C12.9769 5.60295 13.496 5.08049 13.496 4.436C13.496 3.79151 12.9769 3.26904 12.3366 3.26904C11.6963 3.26904 11.1772 3.79151 11.1772 4.436C11.1772 5.08049 11.6963 5.60295 12.3366 5.60295Z",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6505 19.736C37.8437 18.7636 37.8437 17.7911 37.6505 16.8835C36.9419 16.9483 36.3622 16.689 36.169 16.1704C35.9757 15.6517 36.2334 15.0682 36.7487 14.6144C36.2334 13.8364 35.5893 13.1233 34.7519 12.6047C34.301 13.1233 33.7213 13.3826 33.206 13.1881C32.6907 12.9936 32.4331 12.3453 32.4975 11.6322C31.5313 11.4377 30.5651 11.4377 29.6633 11.6322C29.7278 12.3453 29.4701 12.9288 28.9548 13.1233C28.4395 13.3178 27.8598 13.0585 27.4089 12.5398C26.636 13.0585 25.9274 13.7068 25.4121 14.5496C25.9274 15.0034 26.1851 15.5869 25.9918 16.1055C25.7986 16.6242 25.1545 16.8835 24.446 16.8187C24.2527 17.7911 24.2527 18.7636 24.446 19.6712C25.1545 19.6064 25.7342 19.8657 25.9274 20.3843C26.1207 20.903 25.863 21.4865 25.3477 21.9403C25.863 22.7183 26.5071 23.4314 27.3445 23.95C27.7954 23.4314 28.3751 23.1721 28.8904 23.3666C29.4057 23.5611 29.6633 24.2094 29.5989 24.9225C30.5651 25.117 31.5313 25.117 32.4331 24.9225C32.3687 24.2094 32.6263 23.6259 33.1416 23.4314C33.6569 23.2369 34.2366 23.4962 34.6875 24.0149C35.4604 23.4962 36.169 22.8479 36.6843 22.0051C36.169 21.5513 35.9113 20.9678 36.1046 20.4492C36.3622 19.9305 37.0063 19.6712 37.6505 19.736Z",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5927 19.3467C33.013 20.773 31.4027 21.4213 29.9856 20.8378C28.5685 20.2543 27.9244 18.6336 28.5041 17.2073C29.0838 15.781 30.6941 15.1327 32.1112 15.7162C33.5283 16.2997 34.1724 17.9853 33.5927 19.3467Z",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82764 10.8545H21.5474V15.5223H7.82764V10.8545Z",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82764 18.3101H12.9806V22.8482H7.82764V18.3101Z",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82764 25.6362H10.1465",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4925 24.9873L5.18654 34.2581C4.34918 35.0361 4.28477 36.3327 5.12213 37.1107C5.89508 37.8886 7.24774 37.8886 7.95627 37.0458L17.1672 26.6729",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02075 37.0458L17.2317 26.6729",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4863 26.0247C20.4524 25.0522 21.7407 20.1899 21.7407 20.1899C21.7407 20.1899 20.0016 21.4217 17.1674 22.1997C15.1062 22.7832 14.7842 25.7006 16.7165 26.5434C17.6827 26.9323 18.7777 26.7378 19.4863 26.0247Z",
    stroke: "#3E66F3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDev);
export default __webpack_public_path__ + "static/media/web-dev.9d0f2cd4124e76db557e03ca0a3efba4.svg";
export { ForwardRef as ReactComponent };